<template>
	<div class="quiz-btn"  @click="routerLink(link)">
		<div class="h-100 w-100">
			<div class="h-100 d-flex">
				<h1 class="my-auto mx-auto">{{ text }}</h1>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "QuizButton",
	data() {
		return {
			width: '360px',
			height: '78px',
			padding: '14px',
			outerRadius: '25px',
			innerRadius: '15px'
		}
	},
	props: {
		text: String,
		bordertype: {
			Type: String,
			default: "tl"
		},
        link: {
			Type: String,
			default: null
		}
	},
	methods: {
		routerLink(link) {
			
			if( link !== null)
			{
				this.$router.push({ name: link });
			}
		}
	}
};
</script>

<style scoped>

	.quiz-btn {
		width: v-bind(width);
		height: v-bind(height);
		background-color: transparent;
		padding: v-bind(padding);
		border: 2px solid #fff;
	}

	h1 {
		color: #fff;
		margin: 0;
		font-size: 30px;
		font-weight: bold;
	}
</style>